/**
 * Table wrap.
 * - add additional wrapper to table because of horizontal scroll if table has
 * defined width.
 */
const $ = window.jQuery;
const TABLE_WRAPPER = "<div class='responsive_table'></div>";

export default {
  attach: function (context, settings) {
    $(document).ready(function () {
      $(once('tableWrapParagraph',
        '.paragraph > .paragraph__content table,' +
        '.paragraph.faq table',
        context)).each(function () {
        $(this).wrap(TABLE_WRAPPER);

        let styles = $(this).attr('style');
        if ((typeof styles !== 'undefined') && (styles.length)) {
          let $tableWrapper = $(this).closest('.responsive_table');
          $tableWrapper.attr('style', styles);

          if (styles.indexOf('float:left') > -1) {
            $tableWrapper.css('margin-right', '20px');
          }
          else if (styles.indexOf('float:right') > -1) {
            $tableWrapper.css('margin-left', '20px');
          }
        }
      });
    });
  },
};
